import React from 'react'
import type { AnchorHTMLAttributes } from "react"
import { ButtonLook, ButtonSize, getButtonClasses } from '..'

export type LinkButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  size?: ButtonSize
  look?: ButtonLook
  className?: string
}

function LinkButton({
  size = 'md',
  look = 'primary',
  className: additionalClassName = '',
  children,
  ...rest
}: LinkButtonProps) {
  return (<a {...rest} className={getButtonClasses(look, size, additionalClassName)} style={{ textAlign: 'center' }}>
    {children}
  </a>)
}


export default LinkButton
